import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  locationWithoutPermission,
  locationWithPermission,
} from "../../redux/actions/location";
import { countryPhoneCodes } from "../LandingPage/countryPhoneCode";
import WhatsAppVerification from "./WhatsAppVerification/index";
import OtpVerification from "./OtpVerification/index";
import { IKImage } from "imagekitio-react";
import {
  HiringPartnersImg,
  InDemandLinksImg,
  LearnersImg,
  RewardImg,
} from "../LandingPage/imageLinks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import ReactPixel from "react-facebook-pixel";
import FooterLandingPage from "../LandingPage/FooterLandingPage";
import Logo from "../OnboardingRevampPage/Logo";
import "./index.css";
import Footer25 from "../LandingPage25/Footer25";
import NewLogo from "../../components/CNLogo/NewLogo";
import { useNavigate } from "react-router-dom";
import { checkUserAccess } from "../../redux/actions/authentication";
import { AnimatedCompanyBadge } from "../LandingPage25/Lcp";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";
import { capitalizeWords } from "../../utils/subscription";

export default function VerificationPage() {
  const dispatch = useDispatch();
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const [selectedCountry, setSelectedCountry] = useState(
    countryPhoneCodes.find((el) => el?.name === "India"),
  );
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isWhatsApp, setIsWhatsApp] = useState(true);
  const scrollRef = useRef();
  const [isOnboarded, setIsOnboarded] = useState(false);
  const firstName = useSelector((store) => store?.profileDetails?.first_name);
  const access = useSelector((store) => store?.userActivity?.access);
  const type = useSelector((store) => store?.onBoarding?.type);
  const navigate = useNavigate();
  const isPremium = useSelector((state) => state?.onBoarding?.isPremium);
  const successUuid = useSelector((state) => state?.onBoarding?.successUuid);
  const isSeo = useSelector((state) => state?.userActivity?.is_seo);

  useEffect(() => {
    Mixpanel.track(Constants.Mixpanel.NUMBER_VERIFICATION25_PAGE_LOADED);
    dispatch(locationWithoutPermission(user_id));

    const successCallback = async (data) => {
      const latitude = data.coords.latitude;
      const longitude = data.coords.longitude;
      dispatch(locationWithPermission(user_id, latitude, longitude));
    };
    setTimeout(() => {
      navigator.geolocation.getCurrentPosition(successCallback, (error) => {});
    }, 1000);

    setTimeout(() => {
      scrollRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 100);

    ReactPixel.pageView();
  }, [dispatch, user_id]);

  useEffect(() => {
    dispatch(
      checkUserAccess((successObj) => {
        if (successObj?.is_onboarded === true) {
          if (type === "cv") {
            window.location.href = `https://resume.learntube.ai`;
            return;
          } else if (type === "job") {
            navigate("/job-application-guides");
            return;
          } else if (type === "course" && isPremium) {
            window.location.href = `https://personalise.learntube.ai/onboarding/loader-1?uuid=${successUuid}`;
            return;
          } else if (successObj?.number_verification === true) {
            if (isSeo) {
              //decision making point
              navigate("/player-unlock");
            } else {
              navigate(1);
            }
          } else {
            navigate("/courses");
          }
        }
      }),
    );
  }, [dispatch, navigate]);

  return (
    <div
      className="h-full w-full px-4 pt-4 md:px-0 md:pt-6"
      style={{
        background: "radial-gradient(circle, #012744 0%, #010D17 100%)",
      }}
    >
      <div className="mx-auto flex h-full items-center justify-center">
        <NewLogo navigateToHome={() => {}} />
      </div>

      <div className="mx-auto mt-11 flex w-full w-full max-w-[1164px] flex-col md:my-[12dvh] md:flex-row md:items-center md:justify-between md:gap-20">
        <div className="flex w-full flex-col items-start justify-start">
          <div className="flex w-full flex-col items-start justify-center">
            <div className="text-[16px] text-white/70 md:text-[24px]">
              Welcome, {capitalizeWords(firstName)}!
            </div>
            <div className="text-[18px] font-semibold leading-[130%] text-white md:text-[28px]">
              Verify Your Mobile To Secure Your Account
            </div>
          </div>
          <div className="relative mt-[44px] flex w-full md:hidden">
            <img
              alt=""
              className="h-auto w-full"
              src="https://img.learntube.ai/public-assets/LandingPage-2025/Frame%20427322649.webp"
            />
            <div className="absolute bottom-[20%] right-[5%]  h-[90px] w-[90px] md:h-[120px] md:w-[120px] ">
              <div className="relative h-full w-full">
                <img
                  alt="badge"
                  src="https://img.learntube.ai/public-assets/LandingPage-2025/Group%2023588.webp"
                  className="h-full w-full"
                />
                <AnimatedCompanyBadge />
              </div>
            </div>
          </div>
          <div className="relative mt-[44px] hidden w-full flex-col items-start justify-start md:flex">
            <img
              alt=""
              className="h-full w-full"
              src="https://img.learntube.ai/public-assets/LandingPage-2025/hero-illustration.webp"
            />
            <div className="absolute bottom-[20%] right-[10%] h-[120px] w-[120px]">
              <div className="relative h-full w-full">
                <img
                  alt="badge"
                  src="https://img.learntube.ai/public-assets/LandingPage-2025/Group%2023588.webp"
                  className="h-full w-full"
                />
                <AnimatedCompanyBadge />
              </div>
            </div>
          </div>
        </div>
        <WhatsAppVerification
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          setIsWhatsApp={setIsWhatsApp}
          scrollRef={scrollRef}
          isOnboarded={isOnboarded}
        />
        {/* <div className="flex w-full flex-col items-center">
          <div className="card-box-shadow mt-16 flex w-[93%] flex-col rounded-lg border-2 border-[#1CB05E] bg-[#2D4F71] p-4 md:w-2/3 ">
            {isWhatsApp ? (
              
            ) : (
              <OtpVerification
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                setIsWhatsApp={setIsWhatsApp}
                scrollRef={scrollRef}
                isOnboarded={isOnboarded}
              />
            )}
          </div>
        </div> */}
      </div>
      <Footer25 />
    </div>
  );
}
